import * as actionTypes from './actionsTypes';

export const setLoadedFrom = (loadedFrom) => {

  return {
    type: actionTypes.SETLOADEDFROM,
    data: loadedFrom,
  };
};
